import { BlueShipUser } from '../../auth';

// Strips the extension and collapses anything unsafe for a filename/blob name to a single
// underscore, so a user's own upload (e.g. "Q3 Shipments (Final).xlsx") can be echoed into the
// generated blob name — RateQuality's output-filename construction (TriggerFileInfo.cs) takes
// this whole blob name as its base, so keeping it filesystem-safe here keeps that safe too.
const sanitizeFileNameSegment = (value: string, maxLength: number) =>
  value
    .replace(/\.[^./]+$/, '')
    .replace(/[^a-zA-Z0-9_-]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, maxLength);

const getTimestamp = () => {
  const now = new Date();
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = months[now.getMonth()];
  const day = now.getDate().toString().padStart(2, '0');
  const hours = now.getHours().toString().padStart(2, '0');
  const minutes = now.getMinutes().toString().padStart(2, '0');
  const seconds = now.getSeconds().toString().padStart(2, '0');
  const milliseconds = now.getMilliseconds().toString().padStart(3, '0');
  return `${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

export const createFileName = (
  userName: BlueShipUser['userName'],
  accountNumber?: string,
  userFileName?: string,
  originalFileName?: string
) => {
  const timestamp = getTimestamp();
  const baseFileName = `RatingUI-${userName}-${timestamp}.xlsx`;

  // Original upload name first — it's the strongest correlation aid a user has, and now that the
  // prefix is optional, the only one we're guaranteed to have. Each segment stands on its own, so
  // dropping one (e.g. no prefix entered) no longer drops the ones after it, unlike before.
  const segments = [
    originalFileName ? sanitizeFileNameSegment(originalFileName, 40) : '',
    userFileName?.trim() ?? '',
    accountNumber ?? '',
  ].filter(Boolean);

  return segments.length ? `${segments.join('-')}-${baseFileName}` : baseFileName;
};
